const makeArrayOfItemsFromItemOrArrayOfItems = (itemOrArrayOfItems) => {
  if (!Array.isArray(itemOrArrayOfItems)) {
    return [itemOrArrayOfItems];
  }
  return itemOrArrayOfItems;
};

const decodeCustomerId = (encodedCustomerId) => {
  return encodedCustomerId / 9041 - 9041;
};

const encodeCustomerId = (customerId) => {
  return (customerId + 9041) * 9041;
};

/**
 * Find a company department by stable mail key.
 * Prefer `shortname` (same across dossiers); fall back to `name` for older data.
 */
const findDepartmentByShortname = (departments, key) => {
  const needle = String(key || "").trim();
  if (!needle || !Array.isArray(departments)) return null;
  const byShort =
    departments.find(
      (dept) => String(dept?.shortname || "").trim() === needle
    ) || null;
  if (byShort) return byShort;
  return (
    departments.find((dept) => String(dept?.name || "").trim() === needle) ||
    null
  );
};

const getEmailAddressByDossierAndDepartment = ({ dossier, department }) => {
  const departments = dossier?.departments || [];
  return findDepartmentByShortname(departments, department)?.email ?? null;
};

const getPhoneNumberByDossierAndDepartment = ({ dossier, department }) => {
  const departments = dossier?.departments || [];
  return findDepartmentByShortname(departments, department)?.phone ?? null;
};

module.exports = {
  makeArrayOfItemsFromItemOrArrayOfItems,
  decodeCustomerId,
  encodeCustomerId,
  findDepartmentByShortname,
  getEmailAddressByDossierAndDepartment,
  getPhoneNumberByDossierAndDepartment,
};
